<style scoped>

</style>
<template>
  <!--
  <v-textarea
    solo
    name="input-7-4"
    @paste="onPaste"
    label="Solo textarea"
    v-model="code"
  >
  </v-textarea>
-->
  <!--<ace-editor v-model="dataSource.input" @paste="onPaste" @init="editorInit" lang="plain_text" theme="chrome" width="100%" height="600px"></ace-editor>-->
</template>
<script>
  //import VueAceEditor from 'vue2-ace-editor';
  import {createNamespacedHelpers} from 'vuex';
  //import 'brace/ext/language_tools';
  //import 'brace/mode/plain_text';
  //import 'brace/theme/chrome';
  const {
      mapState, mapActions, mapGetters, mapMutations
  } = createNamespacedHelpers('dataSources')

  const editorInstance = null;
  export default {
    data: function() {
      return {
        code: ""
      };
    },
    methods: {
        ...mapMutations(['mSetAceEditor']),
        ...mapActions(['aAdd', 'aSetDataSource', 'aInit', 'aUpdate', 'aPaste']),
        editorInit: function (editor) {
          editor.setOptions({
            enableBasicAutocompletion: true
          });
          this.code = this.dataSource.input;
          this.mSetAceEditor(editor);
        },
        onPaste (e) {
          let clipboardData, pastedData;

          // Stop data actually being pasted into div
          e.stopPropagation();
          e.preventDefault();
          // Get pasted data via clipboard API
          clipboardData = e.clipboardData || window.clipboardData;
          pastedData = clipboardData.getData('Text');
          this.aPaste({dataSource: this.dataSource, input: pastedData});

          // console.log('pasted value');

          // Do whatever with pasteddata
          //alert(pastedData);
          //  console.log('on paste', evt)
      }
    },
    computed: {
        ...mapState(['types', 'dataSources', 'dataSource'])
    },
    components: {
      //'ace-editor': VueAceEditor
    }
  }
</script>
